import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
//import estilos from './UsuariosComponent.module.css'
import moment from 'moment'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import { IconButton } from '@mui/material';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';
import ModalRegistrarUsuarioComponent from './ModalRegistrarUsuarioComponent';
import { agregarUsuarioDA, obtenerUsuarioDA, actualizarUsuarioDA, eliminarUsuarioDA } from '../../../redux/DucksUsuarioAgricola/UsuarioDivisionAgricolaDuck';

function UsuariosAuxiliaresAgricolaComponent(props) {

    const dispatch = useDispatch()
    const [usuarios, setUsuarios] = useState([])

    const [openModal, setOpenModal] = React.useState(false)
    const [titleModal, setTitleModal] = React.useState('')
    const [bodyModal, setBodyModal] = React.useState('')

    const [accion, setAccion] = React.useState('')
    const [idUser, setIdUser] = React.useState('')

    const [openModalAlerta, setOpenModalAlerta] = React.useState(false)
    const [usuarioEliminar, setUsuarioEliminar] = React.useState('')
    const OpenModalAlerta = (data) => {
        setUsuarioEliminar(data)
        setOpenModalAlerta(true)
    }
    const CloseModalAlerta = () => setOpenModalAlerta(false)


    const handleOpenModal = (data) => {
        setBodyModal(data)
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setIdUser('')
        setOpenModal(false)
    }

    React.useEffect(async () => {
        let res = await dispatch(obtenerUsuarioDA())
        setUsuarios(res.payload)
    }, [])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '70%',
        height: '90%',
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        p: 4,
    };

    const styleAlerta = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        p: 4,
    };

    const columns = [
        { field: 'num', headerAlign: 'center', headerName: 'N°', width: 100, },
        { field: 'usuario', headerAlign: 'center', headerName: 'Usuario', width: 540, },
        { field: 'tecnico', headerAlign: 'center', headerName: 'Puesto', width: 400, },
        {
            field: 'accion', headerAlign: 'center', headerName: 'Acción', width: 230,
            renderCell: (params) => (
                <>
                    <IconButton onClick={() => handleOpenModal(params.row)} fontSize="large" sx={{ color: '#81810e', mr: 2 }} title="Editar usuario"> <BorderColorRoundedIcon /> </IconButton>
                    <IconButton onClick={() => OpenModalAlerta(params.row)} fontSize="large" sx={{ color: '#D31919' }} title="Eliminar usuario"> <DeleteRoundedIcon /> </IconButton>
                </>
            )

        }
    ]

    let rows = []
    let numUser = 1
    for (const i in usuarios) {
        let { ...usuario } = usuarios[i]
        rows.push({
            id: `${usuario?.idlogin}`, num: numUser, puesto: usuario?.idrol == 9 ? 'Auxiliar División Agrícola' : '', tecnico: usuario?.idrol == 9 ? 'Técnico de campo' : '',
            usuario: usuario?.usuario, password: usuario.password, permisosagricola: usuario?.permisosagricola
        })
        numUser++
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal open={openModal} onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description" >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "#F30707" }}>
                            <center><strong>{titleModal}</strong></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'justify', fontFamily: 'Montserrat' }}>
                            <ModalRegistrarUsuarioComponent usuarioModify={bodyModal} functionAcept={botonAgregarUsuario} functionActualizar={botonActualizarUsuario}></ModalRegistrarUsuarioComponent>
                        </Typography>
                        <br />
                    </Box>
                </Modal>
            </div>
        )
    }

    const modalAlerta = () => {
        return (
            <div>
                <Modal
                    open={openModalAlerta}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleAlerta}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" style={{ textAlign: 'center' }}>
                            <strong>Advertencia</strong>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 3 }} style={{ textAlign: 'center' }}>
                            ¿Estás seguro que deseas eliminar el usuario seleccionado? <br /> Esta acción es irreversible.
                        </Typography>
                        <Typography sx={{ mt: 5 }} className='text-center'>
                            <button className='btn btn-outline-danger' onClick={CloseModalAlerta} style={{ width: '45%', marginRight: '10%' }} > Cancelar </button>
                            <button className='btn btn-outline-success' onClick={botonEliminarUsuario} style={{ width: '45%' }} > Continuar </button>
                        </Typography>
                    </Box>
                </Modal>
            </div>
        )
    }

    const botonAgregarUsuario = async (dataForm) => {
        const fechaHoy = moment().format('YYYY-MM-DD')

        dataForm.idtipousuario = Number(6)
        dataForm.idrol = Number(9)
        dataForm.fechainscripcion = new Date(fechaHoy).toISOString()
        delete dataForm?.id

        let agregar = await dispatch(agregarUsuarioDA(dataForm))
        setUsuarios([...usuarios, agregar?.payload?.nuevoUsuario]);
        setOpenModal(false)
    }

    const botonActualizarUsuario = async (dataForm) => {
        dataForm.idlogin = Number(dataForm.id)
        dataForm.idtipousuario = Number(6)
        dataForm.idrol = Number(9)
        delete dataForm.id

        let actualizar = await dispatch(actualizarUsuarioDA(dataForm))
        const updatedFields = usuarios.map(usuario => usuario?.idlogin == Number(actualizar?.payload?.idlogin) ? { ...actualizar?.payload } : { ...usuario });
        setUsuarios(updatedFields);
        setOpenModal(false)
    }

    const botonEliminarUsuario = async () => {
        let eliminar = await dispatch(eliminarUsuarioDA(usuarioEliminar.id))
        const updatedFields = []
        usuarios.map(usuario => {
            if (usuario?.idlogin != Number(eliminar?.payload?.data?.data?.idlogin)) {
                updatedFields.push(usuario)
            }
        })
        setUsuarios(updatedFields);
        setOpenModalAlerta(false)
    }

    function QuickSearchToolbar() {
        return (
            <Box sx={{ p: 0.5, pb: 0, mb: 2, textAlign: 'left', height: 30, width: '100%', backgroundColor: 'white' }}>
                <GridToolbarQuickFilter style={{ backgroundColor: '#F8F9F9', width: '100%' }} placeholder='Búsqueda...' />
            </Box>
        );
    }

    return (
        <Fragment>
            <div className='container'>
                <h3 style={{ fontFamily: 'Montserrat', marginTop: '3%' }}> <center> <b>Usuarios División Agrícola</b> </center> </h3>
                <div className='text-end'><button className='btn btn-outline-success' onClick={() => handleOpenModal()} >Agregar usuario</button></div>
                <div style={{ height: 600, width: '100%', marginTop: '2%' }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={10}
                        getRowId={(row) => row.id}
                        rowsPerPageOptions={[7]}
                        components={{ Toolbar: QuickSearchToolbar }}
                        sx={{
                            boxShadow: 0,
                            color: 'black',
                            border: 0,
                            '& .MuiDataGrid-cell': {
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontFamily: 'Montserrat',
                                verticalAlign: 'middle !important'
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#81810e',
                                color: 'white',
                                fontFamily: 'Montserrat',
                                fontWeight: 'bold',
                                height: '20px'
                            }
                        }}
                    />
                </div>
            </div>

            {modalComponent()}
            {modalAlerta()}

        </Fragment>
    );

};

export default withRouter(UsuariosAuxiliaresAgricolaComponent)